
export function getNLSMessages(): string[] {
	return globalThis._NEEDLE_NLS_MESSAGES;
}

export function getNLSLanguage(): string | undefined {
	return globalThis._NEEDLE_NLS_LANGUAGE;
}
